<template>
    <dashboard-layout tit="비밀번호 변경">
        <template slot="contents">
            <vertical-form-table v-model="inputs" :items="items">
                <template slot="새 비밀번호 확인">
                    <v-password-confirm-field v-model="passwordConfirm" :password="inputs.newPassword" @input="(value)=>{ passwordConfirm = value}" outlined />
                </template>
            </vertical-form-table>
            <div class="v-btn-group">
                <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="save"><span>비밀번호 변경</span></v-btn>
            </div>
        </template>
    </dashboard-layout>
</template>

<script>
import api from "@/api";
import CryptoAES from "@/plugins/crypto-aes";
import { attrs_input, rules } from "@/assets/variables";
import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import VPasswordConfirmField from "@/components/plugins/vuetify/v-password-confirm-field.vue";

const items = [
    {
        key: "password",
        term: "현재 비밀번호 ",
        type: "password",
        placeholder: "비밀번호를 입력하세요",
        autocomplete: "new-password",
        rules: rules.password,
    },
    {
        key: "newPassword",
        term: "새 비밀번호 ",
        type: "password",
        placeholder: "비밀번호를 입력하세요",
        autocomplete: "new-password",
        rules: rules.password,
    },
    {
        key: "passwordConfirm",
        term: "새 비밀번호 확인",
    },
].map((item) => ({ ...item, outlined: true }));

export default {
    components: {
        DashboardLayout,
        VerticalFormTable,
        VPasswordConfirmField,
    },
    data: () => ({
        items,
        rules,
        attrs_input,
        inputs: {},
        passwordConfirm: ""
    }),
    methods: {
        async save(){
            try{
                if(!this.validation()) return;
                // this.inputs.password = CryptoAES.encrypt(this.inputs.password);
                // this.inputs.newPassword = CryptoAES.encrypt(this.inputs.newPassword);
                
                await api.v1.me.checkPassword({
                    password: CryptoAES.encrypt(this.inputs.password),
                    newPassword: CryptoAES.encrypt(this.inputs.newPassword)
                });

                alert("비밀번호가 수정되었습니다.");
                this.$router.go(-1);
                
            } catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        validation(){
            const value = this.inputs.newPassword;
            if(!/[~!@#$%^&*()_+|<>?:{}]/.test(value)) throw new Error("비밀번호에 특수문자를 넣어주세요");
            if(!/[a-zA-Z]/.test(value)) throw new Error("비밀번호에 영문을 넣어주세요");
            if(!/[0-9]/.test(value)) throw new Error("비밀번호에 숫자를 넣어주세요");
            if(!(value && 8 <= value.length && value.length <= 16) ) throw new Error("비밀번호를 8 ~ 16자 사이로 작성해주세요");

            if(!(value === this.passwordConfirm)) throw new Error("새 비밀번호가 일치하지 않습니다.");

            return true;
        }
    }
};
</script>

<style></style>
